// noinspection JSUnusedGlobalSymbols

export default class Navigation {
    static reload = () => {
        window.location.reload();
    };

    static getHomeUrl = () => {
        return '/';
    };

    static getProductUrl = (productId, storeId, variantId, source) => {
        let url = `/product/${productId}`;
        let parameters = [];
        if (storeId) parameters.push(`oda=${storeId}`);
        if (variantId) parameters.push(`variant=${variantId}`);
        if (source) parameters.push(`omc=${source}`);
        if (parameters && parameters.length > 0) {
            url += `/?`;
            parameters.forEach((parameter, index) => {
                url += parameter;
                if (index < parameters.length - 1) url += '&';
            });
        }
        return url;
    };

    static getCartUrl = () => {
        return '/cart';
    };

    static getIdentificationUrl = () => {
        return '/identification';
    };

    static getAddressCopyUrl = (path) => {
        let url = '/address-copy';
        if (path) url += `/${path}`;
        return url;
    };

    static getCheckoutUrl = (path) => {
        let url = '/checkout';
        if (path) url += `/${path}`;
        return url;
    };
}